(function () {
    'use strict';

    angular.module('cfn').directive('cfnBookingField', cfnBookingField);

    cfnBookingField.$inject = [
        '$log',
        '$q',
        '$rootScope',
        'analyseService',
        'CfnDialogService',
        'i18nFilter',
        'bookingRules',
        'bookingService',
        'search.service',
        'harvestBookingService',
        'fieldSearchService'
    ];

    function cfnBookingField(
        $log,
        $q,
        $rootScope,
        analyseService,
        CfnDialogService,
        i18nFilter,
        bookingRules,
        bookingService,
        searchService,
        harvestBookingService,
        fieldSearchService
    ) {
        return {
            restrict: 'E',
            templateUrl: require('./fieldTable.html'),
            controller: [
                '$scope',
                function ($scope) {
                    const objectType = $scope.ele.name;
                    const objectTypeGroup = objectType + 'group';
                    const type = 'asset';
                    const list = objectType + 'List';

                    // Load data from common booking state object into local format
                    bookingRules.elements.field.onLoad = function (result) {
                        // result.assets[assetType=="Field"] -> $scope.details.fieldList
                        $scope.details.fieldList = result.assets.filter((dto) => {
                            return dto.assetType === 'Field';
                        });

                        $scope.details.fieldList.forEach(function (item) {
                            //same as inserting a new one
                            bookingRules.elements.field.onInsert(item);
                        });
                    };

                    // Transform details-data (fieldList, seedList, ...) to BE-Data (assets, products,...)
                    bookingRules.elements.field.onSave = function (result) {
                        if (!angular.isArray(result.assets)) result.assets = [];
                        if ($scope.details.fieldList)
                            $scope.details.fieldList.forEach(function (field) {
                                field.assetType = 'Field';
                                result.assets.push(field);
                            });
                    };

                    bookingRules.elements.field.onInsert = function (fieldDTO) {
                        var newItem = fieldDTO;
                        newItem.feid = fieldDTO.asset.id; // set id in item for easy unique-check. we have to delete it in onSave() - otherwise BE is crying
                        var oldFieldSum = $scope.details.fieldList_farmedArea_sum;

                        bookingService.addToList($scope, newItem, 'fieldList');

                        calcFieldListFarmedAreaSum();

                        var newFieldSum = $scope.details.fieldList_farmedArea_sum;
                        updateWorkedArea(oldFieldSum, newFieldSum);

                        // help user with harvest informations if the system wants to help or this is the
                        // first field and the user already added a field before
                        var helpUser =
                            bookingService.harvestHelper.helpUser ||
                            ($scope.details['fieldList'].length === 1 &&
                                bookingService.harvestHelper.helpUser === false);

                        if (helpUser) {
                            bookingService.harvestHelper.helpUser = false; // no longer help the user with the harvest information
                        }
                    };

                    $scope.remove = function (item, index) {
                        var oldFieldSum = $scope.details.fieldList_farmedArea_sum;
                        $scope.controller.removeFromList(
                            'field',
                            'asset',
                            'fieldList',
                            item
                        );
                        calcFieldListFarmedAreaSum();
                        var newFieldSum = $scope.details.fieldList_farmedArea_sum;
                        updateWorkedArea(oldFieldSum, newFieldSum);
                    };

                    // New Field? -> Calc SUM(farmedArea)
                    $scope.$watch('details.fieldList.length', function (
                        newValue,
                        oldValue
                    ) {
                        if (newValue) {
                            calcFieldListFarmedAreaSum();
                        }
                    });

                    // Calc sum of asset.farmedArea
                    var calcFieldListFarmedAreaSum = function () {
                        $scope.details.fieldList_farmedArea_sum = $scope.details.fieldList
                            .map(function (item) {
                                return item.asset.farmedArea;
                            })
                            .reduce(function (p, c) {
                                return p + c;
                            }, 0);
                    };

                    // Update WorkedArea for Person(s) and Machine(s)
                    var updateWorkedArea = function (oldValue, newValue) {
                        var combinedList = ($scope.details.personList || []).concat(
                            $scope.details.machineList || []
                        );

                        // silently update areas and "ha" amounts for Person(s) and Machine(s) if current value is empty or default (=oldValue)
                        combinedList.forEach(function (item) {
                            if (item.workedArea === 0 || item.workedArea === oldValue) {
                                item.workedArea = newValue;
                            }
                            if (item.unit == 'AREAL_HA') {
                                if (item.amount === 0 || item.amount === oldValue) {
                                    item.amount = newValue;
                                }
                            }
                        });

                        // Otherwise ask for override other WorkedAreas
                        var differentWorkedAreas = combinedList.some(function (item) {
                            return item.workedArea.toFixed(2) !== newValue.toFixed(2);
                        });

                        var differentAmounts = combinedList.some(function (item) {
                            return (
                                item.unit == 'AREAL_HA' &&
                                item.amount.toFixed(2) !== newValue.toFixed(2)
                            );
                        });

                        if (differentWorkedAreas || differentAmounts) {
                            CfnDialogService.showYesNoDialog(
                                i18nFilter(
                                    'fe.booking.setWorkedArea.title',
                                    'Flächenangaben übernehmen?'
                                ),
                                i18nFilter(
                                    'fe.booking.setWorkedArea.text',
                                    'Möchten Sie die Flächensumme auf alle abweichenden' +
                                    ' Flächenangaben für Personen und Maschinen übernehmen?'
                                ),
                                function () {
                                    combinedList.forEach(function (item) {
                                        item.workedArea = newValue;
                                        if (item.unit == 'AREAL_HA') {
                                            item.amount = newValue;
                                        }
                                    });
                                }
                            );
                        }
                    };

                    $scope.bookingDataAsLocalDate = function () {   
                        let date = null;
                        if($scope.details.startDate) {
                            date = $scope.details.startDate;
                        } else {
                            date = new Date();
                        }
                        return moment(date).format('YYYY-MM-DD');
                    };
                    
                    $scope.bookingHarvestYear = function () {
                        if ($scope.details.bookingYear) {
                            // Operation has already been booked -> a harvest year is known
                            return $scope.details.bookingYear;
                        } else {
                            // No saved year, so make a "guess"
                            var startDate = new Date($scope.details.startDate);
                            var year = startDate.getFullYear();
                            if (
                                startDate.getMonth() == 0 ||
                                (startDate.getMonth() == 1 && startDate.getDate() <= 15)
                            ) {
                                year--;
                            }
                            return year;
                        }
                    };

                    function getYear() {
                        return $scope.details.startDate
                            ? new Date($scope.details.startDate).getFullYear()
                            : new Date().getFullYear();
                    }

                    /**
                     * custom search function
                     * @param item
                     * @returns {Promise<{searchString: string}>}
                     */
                    $scope.search = async function (item) {
                        // result object for search service
                        let fieldData = {
                            searchString: item,
                            results: []
                        };

                        if (!fieldData || !fieldData.results || fieldData.results.length === 0) {
                            // get fields
                            fieldData.results = await fieldSearchService.searchActiveFieldGroups($scope.details.startDate.getFullYear());

                            // get fieldgroups
                            fieldData.results = fieldData.results.concat(await fieldSearchService.searchActiveFields($scope.bookingDataAsLocalDate()));

                            // get list of field ids for service call
                            let fieldMap = new Map();
                            let fieldIds = fieldData.results.map((field) => {
                                fieldMap.set(field.id, field);
                                return field.id
                            });

                            // get syscultures for fields
                            let sysCultures = await harvestBookingService.getSysCulturesForFields(fieldIds, $scope.details.startDate);
                            // iterate over given syscultures and sync with fields

                            sysCultures.forEach((sysCulture) => {

                                let field = fieldMap.get(sysCulture.fieldId);
                                if (field) {
                                    field.currentCrop = null;
                                    field.currentCrop_abbrFruit = null;
                                    field.currentSeed_name = null;

                                    if (sysCulture.sysCultureDTO) {
                                        let currentCrop = {};
                                        currentCrop.id = sysCulture.sysCultureDTO.id;
                                        currentCrop.name = sysCulture.sysCultureDTO.name;
                                        field.currentCrop = currentCrop;
                                        field.currentSeed_name = sysCulture.sysCultureDTO.name;
                                        field.currentCrop_abbrFruit = sysCulture.sysCultureDTO.abbrFruit;

                                        if(sysCulture.seasonDTO && sysCulture.seasonDTO.harvestYear){
                                            field.season_year = sysCulture.seasonDTO.harvestYear;
                                        } else field.season_year = i18nFilter('fe.reporting.common.openYear');
                                    }
                                }
                            });
                        } // end else

                        // reduce fieldata matching the search string (field number, name or current culture name)
                        if (fieldData.searchString && fieldData.searchString !== '') {
                            let matchedData = [];
                            fieldData.results.forEach((field) => {
                                if (field.name && field.name.toLowerCase().match(fieldData.searchString.toLowerCase()) ||
                                    (field.number && field.number.toLowerCase().match(fieldData.searchString.toLowerCase())) ||
                                    (field.currentCrop && field.currentCrop.name && field.currentCrop.name.toLowerCase().match(fieldData.searchString.toLowerCase())) ||
                                    (field.currentSeed_name && field.currentSeed_name.toLowerCase().match(fieldData.searchString.toLowerCase())) ||
                                    (field.currentCrop_abbrFruit && field.currentCrop_abbrFruit.toLowerCase().match(fieldData.searchString.toLowerCase()))) {
                                    matchedData.push(field);
                                }
                            });
                            // reset results to matched data or to show that nothing was found
                            fieldData.results = matchedData;
                        }

                        doubleCheckSelectedFieldList(fieldData.results);

                        return $q((resolve, reject) => {
                            resolve(fieldData);
                        });
                    };

                    $scope.searchSelected = function (selectedItem) {
                        $scope.addToList(objectType, type, list, null)(selectedItem);
                    };

                    async function doubleCheckSelectedFieldList(results) {
                        let fieldData = {
                            searchString: null,
                            results: results ? results : []
                        };

                            // double check against allready selected fields, remove from searchlist
                            $scope.details.fieldList.forEach((selectedField) => {
                                for (let i = 0; i < fieldData.results.length; i++) {
                                    if (selectedField.asset.id === fieldData.results[i].id) {
                                        fieldData.results.splice(i, 1);
                                    }
                                }
                            });
                    };
                }
            ]
        };
    }
})();
